import Axios from "axios";
import { checkUserUrl } from "../../Utils/Utils";
import { handleUserLog } from "../../Utils/Utils";
const lStorage = JSON.parse(localStorage.getItem("login")) ||
  JSON.parse(localStorage.getItem("admin")) ||
  JSON.parse(localStorage.getItem("emp")) ||
  JSON.parse(localStorage.getItem("reseller"));;
const domain = window.location.host;

if (lStorage != null) {
  var userId = lStorage?.user?.userId;
  var userToken = lStorage?.token;
  var url = lStorage?.url;
}

let oroginURL = checkUserUrl(url);
const RCS_URL = "https://napi.authkey.io/api/rcs";
export const HOST_URL = `${"https://console.authkey.io/api"}`;
export const BASE_URL = "console.authkey.io";
export const HOST_URL_DB2 = `${"https://db2.authkey.io/api"}`;
export const NODE_HOST_URL_v1 = `${"https://napi.authkey.io/api/v1"}`;
export const NODE_HOST_URL_v2 = `${"https://napi.authkey.io/api2/v1"}`;
export const NODE_HOST_URL_v3 = `${"https://napi3.authkey.io/api2/v1"}`;

export const NODE_HOST_URL_API3_v1 = `${"https://napi.authkey.io/api3/v1"}`;

export const NODE_HOST_URL =
  domain === "staging.authkey.io"
    ? `${"https://stagnapi.authkey.io/"}`
    : `${"https://napi.authkey.io/api"}`;
export const REQUEST_URL = `${oroginURL == true ? "https://api.authkey.io/request" : "/restapi/request.php"
  }`;
export const SOCKET_URL = "https://napi2.authkey.io";

export const STAGE_URL="https://stagnapi.authkey.io/api"
// export const STAGE_URL="http://localhost:8000/api"

export const whatsappSummery = async (data) => {
  return Axios.post(
    `${HOST_URL}/whatsapp_report.php`, data
  );
};
export const getWhatsaAppTemplateList = async (data) => {
  return Axios.post(
    `${HOST_URL}/whatsapp_template.php`, data
  );
};

export const campaignContactList = async (data) => {
  return Axios.post(
    `${HOST_URL}/contact-list.php`, data
  );
};

export const contactListAPI = (data) => {
  return Axios.post(
    `${HOST_URL}/contact-list.php`, data
  );
};

export const downloadContactList = (id, type) => {
  window.location.href = `${NODE_HOST_URL}/contact_list?user_id=${userId}&method=list_data_download&token=${userToken}&list_id=${id}&list_type=${type}`;
  handleUserLog(
  "",
  "download_contact_list",
  "contact_list",
  "Contact list downloaded successfully",
  "contact_list",
  "",
  {
    contact_list_id: id,
    list_type: type
  }
);
};

export const WhstappAccountList = async (data) => {
  return await Axios.post(
    `${HOST_URL}/wp_profile.php`, data
  );
};

export const WhstappGalleryList = async (data) => {
  return Axios.post(
    `${HOST_URL}/uploadFileWhatsapp.php`, data
  );
};

export const getBlogPost = async () => {
  return Axios.get(
    `${HOST_URL}/blog.php?user_id=10&method=retrieve&token=68f3dcf1bf51e3e85150867e8df35586`
  );
};

export const getSMSTemplateList = async (data) => {
  return Axios.post(
    `${HOST_URL}/sms_template.php`, data
  );
};

export const getUserPriceList = async (data) => {
  return Axios.post(
    `${HOST_URL}/user_pricelist.php`, data
  );
};

export const getCampaignSMSTemplateList = async (data) => {
  return Axios.post(
    `${HOST_URL}/sms_template.php`, data
  );
};

export const getDLTsmsTemplateList = async (method = "retrieve") => {
  // console.log(
  //   `${HOST_URL}/dlt_template.php?user_id=${userId}&method=${method}&token=${userToken}`
  // );
  return Axios.get(
    `${HOST_URL}/dlt_template.php?user_id=${userId}&method=${method}&token=${userToken}`
  );
};

export const getAllCountryList = async () => {
  return Axios.post(`${HOST_URL}/country_master.php`);
};

export const createWhatsAppCampaign = (data) => {
  return Axios.post(`${HOST_URL}/bulk_campaign_sms.php`, data);
};

export const createSMSCampaign = (data) => {
  return Axios.post(`${HOST_URL_DB2}/bulk_campaign_sms.php`, data);
};

export const conversation = async (data) => {
  return await Axios.post(`${HOST_URL}/netcore_conversation.php`, data);
};

export const getFaq = ({ method = "retrieve", query = null }) => {
  return Axios.get(
    `${HOST_URL}/faq.php?user_id=10&method=${method}&token=68f3dcf1bf51e3e85150867e8df35586&name=${query}`
  );
};

// Agent API

export const whatsAppAgent = async (data) => {
  return Axios.post(`${HOST_URL}/agent.php`, data);
};

export const deleteOPTOUTNumber = async (mobile) => {
  let data = {
    user_id: userId,
    token: userToken,
    method: "delete",
    mobile: mobile,
  };
  return Axios.post(`${HOST_URL}/optout_list.php`, data);
};

export const wp_get_billable_notbillable = (data) => {
  return Axios.post(
    `${HOST_URL}/wp_get_billable_notbillable.php`, data
  );
};

export const UploadImageToServer = (data) => {
  return Axios.post(`${HOST_URL}/blog-gallery.php`, data);
};

export const contactUs = (data) => {
  return Axios.post(`${HOST_URL}/contact-us.php`, data);
};

export const changePassword = (data) => {
  return Axios.post(`${HOST_URL}/change_password.php`, data);
};

export const userProfile = (data) => {
  return Axios.post(
    `${HOST_URL}/profile.php`, data
  );
};

export const userAPIReQuest = (data) => {
  return Axios.post(
    `${HOST_URL}/user_api_request.php`, data
  );
};

export const translateAPI = (data) => {
  return Axios.post(
    `${HOST_URL}/translate/getTranslated.php`, data
  );
};

export const RCSAPI = (data) => {
  return Axios.post(`${RCS_URL}`, data);
};

export const getRCSSenderID = (data) => {
  return Axios.post(`${RCS_URL}`, data);
};

//Notification Setting API 
export const addSettings = (data) => {

  const payload = {
    ...data,
    method: "addSettings", // Add method to distinguish operations
    user_id: userId,
    token: userToken,
    user_type: "admin",
  };

  return Axios.post(`${NODE_HOST_URL_v1}/admin/PannelSettings`, payload, {
    headers: {
      Authorization: `Bearer ${userToken}`,
      "Content-Type": "application/json; charset=utf-8",
    },
  });
};

export const updateSettings = (id, data) => {

  const payload = {
    ...data,
    id: id,
    method: "updateSettings",
    user_id: userId,
    token: userToken,
  };

  return Axios.post(`${NODE_HOST_URL_v1}/admin/PannelSettings`, payload, {
    headers: {
      Authorization: `Bearer ${userToken}`,
      "Content-Type": "application/json; charset=utf-8",
    },
  });
};

export const DeleteSettings = (id) => {

  const payload = {
    id: id, // Include the ID in the payload
    method: "DeleteSettings", // Add method
    user_id: userId,
    token: userToken,
    user_type: "admin",
  };

  return Axios.post(`${NODE_HOST_URL_v1}/admin/PannelSettings`, payload, {
    headers: { Authorization: `Bearer ${userToken}` },
  });
};

export const listSettings = () => {
  const payload = {
    method: "ListSettings",
    user_type: "admin",
    user_id: userId,
    token: userToken,
  };

  return Axios.post(`${NODE_HOST_URL_v1}/admin/PannelSettings`, payload, {
    headers: {
      Authorization: `Bearer ${userToken}`,
      "Content-Type": "application/json; charset=utf-8",
    },
  });
};

//Emailverification API

export const VerificationDetail = (payload) => {
  return Axios.post(`${NODE_HOST_URL_v1}/EmailVerification`, payload, {
    headers: {
      authorization: `Bearer ${userToken}`,
    },
  });
};


//Cross Origin Api
export const CrossOriginApi = async (payload) => {
  // const lStorage = JSON.parse(localStorage.getItem("login"));
  // const userToken = lStorage?.token || "";

  console.log("📤 Sending Payload:", payload); // Debugging log

  return Axios.post(`${NODE_HOST_URL_v1}/admin/CrossOrigin`, payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
    },
  });
};
